module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "reg-box"
  }, [_c('li', {
    staticClass: "errmsg"
  }, [_vm._v("\n      " + _vm._s(_vm.msg) + "\n    ")]), _vm._v(" "), _c('li', [_c('label', [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userData.name),
      expression: "userData.name"
    }],
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "type": "text",
      "placeholder": "姓名"
    },
    domProps: {
      "value": (_vm.userData.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userData, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('label', [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("手机号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userData.phone),
      expression: "userData.phone"
    }],
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "type": "text",
      "placeholder": "手机号"
    },
    domProps: {
      "value": (_vm.userData.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userData, "phone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('label', [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("邮箱")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userData.email),
      expression: "userData.email"
    }],
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "type": "text",
      "placeholder": "邮箱"
    },
    domProps: {
      "value": (_vm.userData.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userData, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('label', [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userData.pwd),
      expression: "userData.pwd"
    }],
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.userData.pwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userData, "pwd", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "login"
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px"
    },
    on: {
      "click": _vm.doSign
    }
  }, [_vm._v("登录")])])]), _vm._v(" "), _c('div', {
    staticClass: "reg-btn-box"
  }, [_c('button', {
    staticStyle: {
      "font-size": "16px"
    },
    on: {
      "click": _vm.doReg
    }
  }, [_vm._v("确认")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./zhuce.png"),
      "alt": ""
    }
  }), _vm._v("新用户注册\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c9596b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tiantan/register_cn.vue
// module id = 800
// module chunks = 10